import React from "react";
import { Paper } from "@material-ui/core";
import TitleBox from "../components/common/TitleBox";
import ReportListItem from "../components/Main/ReportSection/ReportListItem";
import { useHistory } from "react-router-dom";
import {prm} from "../mocks";

export default function OperatorDetails(props) {
  const history = useHistory();
  const { passenger } = props.location.state;

  const handleItemPress = passenger => {
    console.log("Premuto ", passenger);
  };

  return (
    <Paper square elevation={0}>
      <TitleBox title={"Attività in corso"} greyBackground />
      <ReportListItem
        passenger={prm[Math.floor(Math.random() * prm.length)]}
        onPress={handleItemPress.bind(this)}
      />
      <TitleBox title={"Completate"} greyBackground />
      <ReportListItem
        passenger={prm[Math.floor(Math.random() * prm.length)]}
        onPress={handleItemPress.bind(this)}
      />
      <ReportListItem
        passenger={prm[Math.floor(Math.random() * prm.length)]}
        greyBackground
        onPress={handleItemPress.bind(this)}
      />
      <ReportListItem
        passenger={prm[Math.floor(Math.random() * prm.length)]}
        onPress={handleItemPress.bind(this)}
      />
    </Paper>
  );
}
